type DidRenewalPaymentPlanConfigChangeProps = {
  previousTorType?: string;
  nextTorType?: string;
  previousBreakdownMode?: string;
  nextBreakdownMode?: string;
};

/** True when lease type or payment breakdown mode changed in renewal terms. */
export const didRenewalPaymentPlanConfigChange = (props: DidRenewalPaymentPlanConfigChangeProps) => {
  const { previousTorType, nextTorType, previousBreakdownMode, nextBreakdownMode } = props;

  const torTypeChanged = nextTorType != null && previousTorType != null && nextTorType !== previousTorType;
  const breakdownModeChanged =
    nextBreakdownMode != null && previousBreakdownMode != null && nextBreakdownMode !== previousBreakdownMode;

  return torTypeChanged || breakdownModeChanged;
};
